import { createFileRoute } from "@tanstack/react-router";
import EditListingV2 from "@/pages/EditListingV2";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/edit-listing-v2/$id/")({
  head: ({ params }) => routeHead("/uk/edit-listing-v2/$id/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <EditListingV2 />
  );
}
